var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 24C1.3 24 0 22.7 0 21C0 19.3 1.3 18 3 18C4.7 18 6 19.3 6 21C6 22.7 4.7 24 3 24ZM3 20C2.4 20 2 20.4 2 21C2 21.6 2.4 22 3 22C3.6 22 4 21.6 4 21C4 20.4 3.6 20 3 20Z",
    fill: "#01A0C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24C19.3 24 18 22.7 18 21C18 19.3 19.3 18 21 18C22.7 18 24 19.3 24 21C24 22.7 22.7 24 21 24ZM21 20C20.4 20 20 20.4 20 21C20 21.6 20.4 22 21 22C21.6 22 22 21.6 22 21C22 20.4 21.6 20 21 20Z",
    fill: "#01A0C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C10.3 24 9 22.7 9 21C9 19.3 10.3 18 12 18C13.7 18 15 19.3 15 21C15 22.7 13.7 24 12 24ZM12 20C11.4 20 11 20.4 11 21C11 21.6 11.4 22 12 22C12.6 22 13 21.6 13 21C13 20.4 12.6 20 12 20Z",
    fill: "#01A0C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.3 6 9 4.7 9 3C9 1.3 10.3 0 12 0C13.7 0 15 1.3 15 3C15 4.7 13.7 6 12 6ZM12 2C11.4 2 11 2.4 11 3C11 3.6 11.4 4 12 4C12.6 4 13 3.6 13 3C13 2.4 12.6 2 12 2Z",
    fill: "#01A0C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20C20.4 20 20 19.6 20 19V14C20 13.4 19.6 13 19 13H5C4.4 13 4 13.4 4 14V19C4 19.6 3.6 20 3 20C2.4 20 2 19.6 2 19V14C2 12.3 3.3 11 5 11H19C20.7 11 22 12.3 22 14V19C22 19.6 21.6 20 21 20Z",
    fill: "#01A0C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C11.4 20 11 19.6 11 19V12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12V19C13 19.6 12.6 20 12 20Z",
    fill: "#01A0C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C11.4 13 11 12.6 11 12V5C11 4.4 11.4 4 12 4C12.6 4 13 4.4 13 5V12C13 12.6 12.6 13 12 13Z",
    fill: "#01A0C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.03586328.svg";
export { ForwardRef as ReactComponent };